import { Helmet } from "react-helmet-async";
import Hero from "./Hero";
import About from "./About";
import Services from "./Services";
import Team from "./Team";
import Contact from "./Contact";

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Cabinet Dentaire Temara – Dr. Youssef Lachhab</title>
        <meta
          name="description"
          content="Cabinet Dentaire à Témara offrant des soins dentaires complets, orthodontie, implantologie, esthétique et urgences dentaires. Prenez rendez-vous dès aujourd'hui !"
        />
        <meta property="og:title" content="Cabinet Dentaire Temara – Dr. Youssef Lachhab" />
        <meta
          property="og:description"
          content="Soins dentaires modernes : implantologie, orthodontie, blanchiment, prothèses et urgences dentaires à Témara."
        />
        <meta
          property="og:image"
          content="https://centredentairetemara.ma/images/logo_horizontal_no_background.png"
        />
        <meta property="og:url" content="https://centredentairetemara.ma/" />
        <meta property="og:type" content="website" />
      </Helmet>

      <Hero id="hero" />
      <About id="about" isHome={true}/>
      <Services id="services" isHome={true}/>
      <Team id="team" isHome={true}/>
      <Contact id="contact" isHome={true}/>
    </>
  );
};

export default HomePage;
